import PropTypes from 'prop-types'
import React, {  useState } from "react";
import { Col, Modal, ModalBody, Row ,ModalHeader, Label} from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation";

// Redux
import {  useSelector} from "react-redux";


import MySelect from "./components/test";
import CrearCasoModal from './components/CrearCasoModal';



const CrearEditModal = ({ 
  crearModal,
   onCloseClick, 
   isEdit,
   handleValidEventSubmit,
    event,
     onChange,
     agenda,
     handleDeleteEvent,
     grupo_tecnico,
     setFormData,
     formData
  
   
    }) => {

  const user = useSelector(state => state.User.user) || []
  const userFilter = Array.isArray(user)? user.filter(item=> item.rol === "Agente"):  []
    const contact = useSelector(state => state.Contacts.contacts) || []
    const contactFilter = Array.isArray(contact) ? contact.filter(item => userFilter.some(user => user.id === item.user_vinculado)) : [];
   console.log(contactFilter)
    const casos = useSelector(state => state.Casos.casos.data) || []
    console.log(casos)
    const casosFiltert = Array.isArray(casos)? casos.filter(item=> item.estatus ==='EN ESPERA'):[]
    console.log(casosFiltert)
    const grupoTecnico = useSelector(state => state.GrupoTecnico.grupotecnico) || []

    const [caso, setCaso] = useState(false)  
   



    
   
    const sd = contact && contact.filter(item => item.grupo_tecnico === Number(grupo_tecnico))

  
  
    const handleButtonClick = () => {
        onCloseClick(); // Llama a la función onCloseClick pasada como prop desde el componente padre
      
      };

    const callDeleteClick = () => {
      handleDeleteEvent()
     
    }

    const crearCaso = () => {
      setCaso(!caso)
    }
   
    const onCloseCasoClick = () => {
      setCaso(!caso)
    }
   
    return ( 
        <>

          {
            caso?(
              <CrearCasoModal
              caso={caso}
              onCloseCasoClick={onCloseCasoClick}
              >

              </CrearCasoModal>
            ):null
          }

        
       
            <Modal isOpen={crearModal} toggle={onCloseClick} centered={true}>
                <ModalHeader toggle={handleButtonClick} tag="h4">
                {!!isEdit ? "Edit Event" : "Add Event"}
                        
                </ModalHeader>


                <ModalBody>
                          <AvForm onValidSubmit={handleValidEventSubmit}>
                            <Row form>
                            <Row>
                            <Col lg={6}>
                            
                            <Label
                                                            
                                                            for="accountlist"
                                                            className="col-form-label col-sm-4 d-flex"
                                                          >
                                                        <strong>Casos</strong><span className="text-danger">*</span> 
                                                          </Label>

                                                       
                                                          <select  
                                                           className="form-select"
                                                           id="casos"
                                                           name="casos"
                                                           placeholder ="Seleccione"
                                                           
                                                           onChange={onChange}
                                                          
                                                           
                                                         >
                                                          {
                                                            agenda !== null ? (
                                                              <option value="">{agenda.caso}</option>
                                                            ): (
                                                              <option value="">Seleccione</option>
                                                            )
                                                          }
                                                           {Array.isArray(casos)?
                                                                      casos.map((item) => (
                                                                        <option
                                                                          key={item.id}
                                                                          value={item.id}
                                                                        >
                                                                          {item.id}
                                                                        </option>
                                                                      )):[]}

                                                          </select>
                            </Col>

                            <Col lg={6} 
                                className='mt-2 '

                            >
                            
                            <button
                                    type="submit"
                                    className="mt-4 btn btn-success save-event "
                                    onClick={()=> crearCaso()}

                                  >
                                    Crear Caso
                              </button>
                            </Col>

                            </Row>
                            




                                                          <Label
                                                            
                                                            for="grupo_tecnico"
                                                            className="col-form-label col-sm-4 d-flex"
                                                          >
                                                        <strong>Grupo de Tecnicos</strong><span className="text-danger">*</span> 
                                                          </Label>

                                                       
                                                          <select  
                                                           className="form-select"
                                                           id="grupo_tecnico"
                                                           name="grupo_tecnico"
                                                           placeholder ="Seleccione"
                                                           
                                                           onChange={onChange}
                                                          
                                                           
                                                         >
                                                          {
                                                            agenda !== null ? (
                                                              <option value="">{agenda.grupo_tecnico}</option>
                                                            ): (
                                                              <option value="">Seleccione</option>
                                                            )
                                                          }
                                                           {grupoTecnico &&
                                                                      grupoTecnico.map((item) => (
                                                                        <option
                                                                          key={item.id}
                                                                          value={item.id}
                                                                        >
                                                                          {item.nombre}
                                                                        </option>
                                                                      ))}

                                                          </select>


                                                      

                                                      <Label
                                                            
                                                            for="accountlist"
                                                            className="col-form-label col-sm-4 d-flex"
                                                          >
                                                        <strong>Contacto</strong><span className="text-danger">*</span> 
                                                          </Label>

{/*                                                        
                                                          <select  
                                                           className="form-select"
                                                           id="contacto"
                                                           name="contacto"
                                                           placeholder ="Seleccione"
                                                           
                                                           onChange={onChange}
                                                          
                                                           
                                                         >
                                                          {
                                                            agenda !== null ? (
                                                              <option value="">{agenda.contacto}</option>
                                                            ): (
                                                              <option value="">Seleccione</option>
                                                            )
                                                          }
                                                           {sd &&
                                                                      sd.map((item) => (
                                                                        <option
                                                                          key={item.id}
                                                                          value={item.id}
                                                                        >
                                                                          {item.first_name ? item.first_name : item.razon_social}
                                                                        </option>
                                                                      ))}

                                                          </select> */}


                                                        <MySelect  
                                                           
                                                           id="contacto"
                                                           name="contacto"
                                                           placeholder ="Seleccione"
                                                           isMulti
                                                           allowSelectAll
                                                           options ={ sd && sd.map(item => ({label:item.first_name, value:item.id}))}
                                                           onChange={(item) => setFormData({
                                                            ...formData,
                                                            contacto : item && item.map( item => item.value)
                                                          })}            
                                                           
                                                         />



                              <Col className="col-12 mb-3">
                                <AvField
                                  name="title"
                                  label="Event Name"
                                  type="text"
                                  errorMessage="Invalid name"
                                  validate={{
                                    required: { value: true },
                                  }}
                                  defaultValue={event.title ? event.title : ""}
                                />
                              </Col>
                              <Col className="col-12 mb-3">
                                <AvField
                                  type="select"
                                  name="category"
                                  label="Select Category"
                                  validate={{
                                    required: { value: true },
                                  }}
                                  defaultValue={event.category ? event.category : "bg-primary"}
                                >
                                  <option value="bg-danger">Danger</option>
                                  <option value="bg-success">Success</option>
                                  <option value="bg-primary">Primary</option>
                                  <option value="bg-info">Info</option>
                                  
                                  <option value="bg-warning">Warning</option>
                                </AvField>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <div className="text-end">
                                  <button
                                    type="button"
                                    className="btn btn-light me-2"
                                    onClick={handleButtonClick}
                                  >
                                    Close
                                  </button>
                                  {!!isEdit && (
                                    <button
                                      type="button"
                                      className="btn btn-danger me-2"
                                      onClick={callDeleteClick}
                                    >
                                      Delete
                                    </button>
                                  )}
                                  <button
                                    type="submit"
                                    className="btn btn-success save-event"
                                  >
                                    Save
                                  </button>
                                </div>
                              </Col>
                            </Row>
                          </AvForm>
                        </ModalBody>
            </Modal>

            </>
            
        
     );
}
CrearEditModal.propTypes = {
    onCloseClick: PropTypes.func,
    
    show: PropTypes.any
  }
   


export default CrearEditModal;